import React, { useEffect, useRef, useState } from 'react';
import { CircularProgress } from '@mui/material';
import Vimeo from '@vimeo/player';

import './_customVideoPlayer.scss';

interface CustomVideoPlayerProps {
  videoId: number;
  width?: string | number;
  height?: string | number;
}

const CustomVideoPlayer: React.FC<CustomVideoPlayerProps> = ({ videoId, width = '100%', height = '100%' }) => {
  const [isLoading, setIsLoading] = useState(true);
  const playerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!playerRef.current) return;

    const player = new Vimeo(playerRef.current, {
      id: videoId,
      width: typeof width === 'number' ? width : undefined,
      height: typeof height === 'number' ? height : undefined,
      autoplay: true,
    });

    player.on('loaded', () => {
      setIsLoading(false);
      player.play();
    });

    return () => {
      player.destroy();
    };
  }, [videoId, width, height]);

  return (
    // eslint-disable-next-line no-inline-styles/no-inline-styles
    <div style={{ position: 'relative', width, height }}>
      <div className="custom-video-player" ref={playerRef} />
      {isLoading && (
        <CircularProgress
          sx={{ color: '#fff', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
        />
      )}
    </div>
  );
};

export default CustomVideoPlayer;
